export default __webpack_public_path__ + "static/media/points-256px-blue.8fbca25f.png";